import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import CallButton from "../components/CallButton";
import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function MainLayout() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/") {
      document.getElementById("hero-loader")?.remove();
    }
  }, [location.pathname]);

  return (
    <>
        <Navbar />
        <Outlet />
        <Footer />
        <CallButton />
    </>
  );
}